export const Metadata_TagGroup = {
    key: {
        valueType: 'string',
        optional: false,
        description: 'The parent tag of this group',
    },
    value: {
        valueType: 'string[]',
        optional: false,
        description: 'An array of children under the parent tag',
        metadata: {
            valueType: 'string',
            optional: false,
            description: 'Tag ID'
        }
    }
};
//# sourceMappingURL=types.js.map